import { LoadAswMasterInfo } from '@lib/interfaces';

/**
 * チェックイン系で読み込むマスター一覧
 */
type MasterKeys =
  | 'AIRLINE_I18NJOIN_BY_AIRLINE_CODE'
  | 'AIRPORT_I18NJOIN_BY_AIRPORT_CODE'
  | 'EQUIPMENT_I18N_BY_ACV'
  | 'EQUIPMENT_BY_ACV'
  | 'COUNTRY_I18NJOIN_BY_COUNTRY_2_LETTER_CODE'
  | 'COUNTRY_I18NJOIN_BY_COUNTRY_3_LETTER_CODE'
  | 'MILEAGE_PROGRAM_BY_CARRIER_CODE'
  | 'STATE_BY_STATE_CODE'
  | 'V_LIST_DATA_CABIN_CLASS_BY_SEARCH_KEY'
  | 'FUNCTION_INELIGIBLE_REASON'
  | 'GENDER_BY_GENDER_FOR_CHECKIN'
  | 'LANG_CODE_CONVERT_BY_LANG'
  | 'OFFICE_BY_OFFICE_CODE'
  | 'POS_BY_COUNTRY_2_LETTER_CODE'
  | 'POS_COUNTRY_ALL'
  | 'POS_COUNTRY_ALL_SMS'
  | 'COUNTRY_COUNTRYI18N_ALL'
  | 'AIRCRAFT_CABIN_CHECKIN_VIEW_BY_ACV_AND_CABIN'
  | 'AIRCRAFT_CABIN_CHECKIN_VIEW_I18N_JOIN_BY_ACV_AND_CABIN'
  | 'AIRPORT_TIME_DIFF_BY_AIRPORT_CODE'
  | 'DEPARTURE_AIRPORT_JAPAN_WITHOUT_MULTI_AIRPORT_CITY'
  | 'DESTINATION_AIRPORT_JAPAN_WITHOUT_MULTI_AIRPORT_CITY'
  | 'REGION_JAPAN'
  | 'FF_PRIORITY_CODE_LANG'
  | 'LIST_DATA_All';

/**
 * チェックイン系で読み込むマスターの一覧オブジェクト
 */
export const LOAD_MASTERS: Record<MasterKeys, LoadAswMasterInfo> = {
  AIRLINE_I18NJOIN_BY_AIRLINE_CODE: {
    key: 'airlineI18nJoinByAirlineCode',
    fileName: 'Airline_I18nJoin_ByAirlineCode',
    isCurrentLang: true,
  },
  AIRPORT_I18NJOIN_BY_AIRPORT_CODE: {
    key: 'airportI18nJoinByAirportCode',
    fileName: 'Airport_I18nJoin_ByAirportCode',
    isCurrentLang: true,
  },
  EQUIPMENT_I18N_BY_ACV: {
    key: 'equipmentI18nJoinByAcv',
    fileName: 'Equipment_I18nJoin_ByAcv',
    isCurrentLang: true,
  },
  EQUIPMENT_BY_ACV: {
    key: 'equipmentByAcv',
    fileName: 'Equipment_ByAcv',
  },
  COUNTRY_I18NJOIN_BY_COUNTRY_2_LETTER_CODE: {
    key: 'countryI18nJoinByCountry2LetterCode',
    fileName: 'Country_I18nJoin_ByCountry2letterCode',
    isCurrentLang: true,
  },
  COUNTRY_I18NJOIN_BY_COUNTRY_3_LETTER_CODE: {
    key: 'countryI18nJoinByCountry3LetterCode',
    fileName: 'Country_I18nJoin_ByCountry3letterCode',
    isCurrentLang: true,
  },
  MILEAGE_PROGRAM_BY_CARRIER_CODE: {
    key: 'mileageProgramI18nByCarrierCode',
    fileName: 'Mileage_Program_I18n_ByCarrierCode',
    isCurrentLang: true,
  },
  STATE_BY_STATE_CODE: {
    key: 'stateByStateCode',
    fileName: 'State_ByStateCode',
    isCurrentLang: true,
  },
  V_LIST_DATA_CABIN_CLASS_BY_SEARCH_KEY: {
    key: 'vListDataCheckinCabinClassBySearchKey',
    fileName: 'VListDataCheckinCabinClass_BySearchKey',
    isCurrentLang: true,
  },
  FUNCTION_INELIGIBLE_REASON: {
    key: 'functionIneligibleReason',
    fileName: 'FunctionIneligibleReason',
  },
  GENDER_BY_GENDER_FOR_CHECKIN: {
    key: 'genderByGenderForCheckin',
    fileName: 'Gender_ByGender_ForCheckin',
    isCurrentLang: true,
  },
  LANG_CODE_CONVERT_BY_LANG: {
    key: 'langCodeConvertByLang',
    fileName: 'LangCodeConvert_ByLang',
  },
  OFFICE_BY_OFFICE_CODE: {
    key: 'officeByOffceCode',
    fileName: 'Office_ByOffceCode',
  },
  POS_BY_COUNTRY_2_LETTER_CODE: {
    key: 'posByCountry2LetterCode',
    fileName: 'Pos_ByCountry2LetterCode',
  },
  POS_COUNTRY_ALL: {
    key: 'posCountryAll',
    fileName: 'PosCountry_All',
    isCurrentLang: true,
  },
  POS_COUNTRY_ALL_SMS: {
    key: 'countryWithPosCountryForSmsSendTelNumber',
    fileName: 'Country_WithPosCountryForSmsSendTelNumber',
    isCurrentLang: true,
  },
  COUNTRY_COUNTRYI18N_ALL: {
    key: 'countryCountryI18nAll',
    fileName: 'Country_CountryI18n_All',
    isCurrentLang: true,
  },
  AIRCRAFT_CABIN_CHECKIN_VIEW_BY_ACV_AND_CABIN: {
    key: 'AircraftCabinCheckinView_ByAcvAndCabin',
    fileName: 'AircraftCabinCheckinView_ByAcvAndCabin',
  },
  AIRCRAFT_CABIN_CHECKIN_VIEW_I18N_JOIN_BY_ACV_AND_CABIN: {
    key: 'AircraftCabinCheckinView_I18nJoin_ByAcvAndCabin',
    fileName: 'AircraftCabinCheckinView_I18nJoin_ByAcvAndCabin',
    isCurrentLang: true,
  },
  AIRPORT_TIME_DIFF_BY_AIRPORT_CODE: {
    key: 'AirportTimeDiff_ByAirportCode',
    fileName: 'AirportTimeDiff_ByAirportCode',
  },
  DEPARTURE_AIRPORT_JAPAN_WITHOUT_MULTI_AIRPORT_CITY: {
    key: 'departureAirportJapan_WithoutMultiAirportCity',
    fileName: 'DepartureAirport_Japan_WithoutMultiAirportCity',
    isCurrentLang: true,
  },
  DESTINATION_AIRPORT_JAPAN_WITHOUT_MULTI_AIRPORT_CITY: {
    key: 'destinationAirportJapan_WithoutMultiAirportCity',
    fileName: 'DestinationAirport_Japan_WithoutMultiAirportCity',
    isCurrentLang: true,
  },
  REGION_JAPAN: {
    key: 'regionJapan',
    fileName: 'Region_Japan',
    isCurrentLang: true,
  },
  FF_PRIORITY_CODE_LANG: {
    key: 'FFPriorityCodeLang',
    fileName: 'FFPriorityCode_Lang',
    isCurrentLang: true,
  },
  LIST_DATA_All: {
    key: 'ListData_All',
    fileName: 'ListData_All',
  },
};
